var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2594 5.52187L11.1031 1.36562C10.9844 1.24687 10.8656 1.1875 10.6875 1.1875H4.75C4.09688 1.1875 3.5625 1.72188 3.5625 2.375V16.625C3.5625 17.2781 4.09688 17.8125 4.75 17.8125H14.25C14.9031 17.8125 15.4375 17.2781 15.4375 16.625V5.9375C15.4375 5.75938 15.3781 5.64062 15.2594 5.52187ZM10.6875 2.6125L14.0125 5.9375H10.6875V2.6125ZM14.25 16.625H4.75V2.375H9.5V5.9375C9.5 6.59062 10.0344 7.125 10.6875 7.125H14.25V16.625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 13.0625H13.0625V14.25H5.9375V13.0625ZM5.9375 9.5H13.0625V10.6875H5.9375V9.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonDocument);
export default __webpack_public_path__ + "static/media/carbon_document.f934fff717606fbb1e15b3e8b85583a9.svg";
export { ForwardRef as ReactComponent };